// removed by extract-text-webpack-plugin
module.exports = {"root":"Item__root__Z_UyN","media":"Item__media__1AyDT","button":"Item__button__3tfdi","Text":"Item__Text__f-QeR","card":"Item__card__3HG1b","price":"Item__price__3FFoI","img":"Item__img__-IzwX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/items/item/Item.css
// module id = 292
// module chunks = 0